/**
 * Last-resort fallback copy. The config's `texts.shell` comes first (decision 43); these show
 * only where the config isn't available: the config's own loading and error states, and the home card until its
 * config copy loads. The My Jobs button's text comes from My Jobs itself (its translations); `jobButton` is the
 * default when it gives none (decision 102).
 */
export const COPY = {
  entryCard: {
    title: 'Onboarding form',
    body: 'Complete your joining details before your first day.',
    jobId: 'Job ID',
  },
  jobButton: 'Onboarding In Progress',
  loading: 'Loading your onboarding form…',
  loadError: {
    title: 'We couldn’t load your onboarding form',
    retry: 'Try again',
  },
} as const;
